import Kitchen from './Orders';

export default Kitchen;
